/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Form, Select, DatePicker } from 'antd'
import _ from 'lodash'
import { observer } from 'mobx-react'
import { compose } from 'recompose'
import { 
	GENERIC_LOOKUP, SCHOOL_TYPE, YEAR_LEVEL, EDUCATIONAL_ATTAINMENT
} from '../../../../constants/lookup'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
		}
	}

	render() {
		const { form } = this.props
		const { getFieldDecorator } = form
        
		return (
			<React.Fragment>
				<Row gutter={16}>
					<Col md={4} sm={24}>
						<Form.Item label='Schooling'>
							{ getFieldDecorator('schooling', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}]
							})
							(
								<Select placeholder='Select Schooling'>
									{
										GENERIC_LOOKUP.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							)}
						</Form.Item>
					</Col>
					<Col md={4} sm={24}>
						<Form.Item label='School Type'>
							{ getFieldDecorator('school_type', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}]
							})
							(
								<Select placeholder='Select School type'>
									{
										SCHOOL_TYPE.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							)}
						</Form.Item>
					</Col>
					<Col md={4} sm={24}>
						<Form.Item label='Year/Level'>
							{ getFieldDecorator('year_level', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}]
							})
							(
								<Select placeholder='Select School type'>
									{
										YEAR_LEVEL.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							)}
						</Form.Item>
					</Col>
					<Col md={6} sm={24}>
						<Form.Item label='Course'>
							{ getFieldDecorator('course', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input placeholder='Enter Course' />
							)}
						</Form.Item>
					</Col>
					<Col md={6} sm={24}>
						<Form.Item label='Highest Educational Attainment'>
							{ getFieldDecorator('educational_attainment', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}]
							})
							(
								<Select placeholder='Select Educational Attainment'>
									{
										EDUCATIONAL_ATTAINMENT.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							)}
						</Form.Item>
					</Col>
				</Row>
			</React.Fragment>
		)
	}
}

const composed = compose(
	observer
)

export default composed(Index)
